export const tripStates = [
  {
    label: 'Created',
    key: 'CREATED',
  },
  {
    label: 'Completed',
    key: 'COMPLETED',
  },
  {
    label: 'Canceled',
    key: 'CANCELED',
  },
  {
    label: 'Accepted',
    key: 'ACCEPTED',
  },
  {
    label: 'Arrived',
    key: 'ARRIVED',
  },
  {
    label: 'In progress',
    key: 'IN_PROGRESS',
  },
  {
    label: 'Looking for driver',
    key: 'LOOKING_FOR_DRIVER',
  },
  {
    label: 'No driver found',
    key: 'NO_DRIVER_FOUND',
  },
]
export const metric = [
  {
    label: 'Duration',
    key: 'DURATION',
  },
  {
    label: 'Distance',
    key: 'DISTANCE',
  }]
export const userType = [
  {
    label: 'Driver',
    key: 'driver',
  },
  {
    label: 'User',
    key: 'user',
  },
  {
    label: 'Admin',
    key: 'admin',
  },
]
export const operators = [
  {
    label: 'Greater Than',
    key: 'GREATER_THAN',
  },
  {
    label: 'Less Than',
    key: 'LESS_THAN',
  },
]

export const finesUsers = [
  {
    label: 'Driver',
    key: 'driver',
  },
  {
    label: 'User',
    key: 'user',
  },
  {
    label: 'Admin without fee',
    key: 'admin_with_out_fee',
  },
  {
    label: 'Admin with fee on driver',
    key: 'admin_fee_on_driver',
  },
  {
    label: 'Admin with fee on user',
    key: 'admin_fee_on_user',
  },
]
